import { parse } from "graphql";
export const MESSAGE = `
            messageId
            secureDataEnabled
            aiSubject
            aiReview{
            createdAt
            reviewCriteria {
                    reviewCriteriaId
                    score
                    reasoning
                }
                reviewNotes 
            }
            aiRespond {
                respondResponseCode {
                    responseCode
                    responseCodeDescription
                    reasoning
                }
                respondTags {
                    tags
                    reasoning
                }
                respondClassification {
                    classificationCode
                    classificationCodeDescription
                    reasoning
                }
                respondNextDialogue {
                    nextDialogue
                    nextLifecycleAction
                    reasoning
                }
                lastCustomerDialogueId
                createdAt
                isAIRespondFailed
            }
            author
            country
            language
            body
            state
            groupName
            displayName
            tenantName
            knowledgeBaseIsActive
            custResolved
            viewCustAuth
            viewRespAuth
            enableAttachment
            allowedAttachmentTypes
            respCodeUIControl
            msgClassificationUIControl
            dialogueNoteUIControl
            expertPrefUIControl
            custConfirmationUIControl
            custConfirmationState
            custTestimonial
            tagUIControl
            created
            assignedExpertId
            customerData
            tags
            responseCode
            responseCodeDesc
            escalateNote
            escalateReason
            escalateReasonDesc
            reportNote
            reportReason
            customerScore
            qualityReviewMessageId
            reportReasonDesc
            msgClassification {
                classificationCode
                classificationCodeDescription
                attributes {
                    name
                    label
                    value
                }
            }
            msgClassificationMetaData {
                classificationCode {
                    label
                    name
                    hint
                }
                attributes {
                    name
                    default
                    label
                    hint
                    enabled
                    type
                }
            }
            dialogues {
                dialogueId
                origin
                type
                created
                author
                userId
                body
                attachments {
                    contentType
                    created
                    fileName
                    scannedStatus
                    size
                    url
                    valid
                }
                suggestedAnswers {
                    body
                    dialogueId
                    state
                    suggestedAnswerScore
                }
                contentModerated {
                    action
                    reason
                }
                translatedFrom
                locale
                userType
            }
            expertAuthors
            inbox {
                messageId
                expires
                claimed
                passed
                reward
                rewardFee
                points
                userId
                groupName
                tenantName
                type
                assignedExpertExpiry
                claimedAt
                claimTimeout
                claimTimeoutInc
                userId
            }
            reviewScore,
            custScoreScheme {
                name
                maxScore
            }
            reviewRequiredVotingExperts
            replyUIControl
            claimExtendUIControl
            reviewCriteria {
                name
                description
                reviewScheme
                weight
                score,
                reviewCriteriaId
                optional
                text
            }
            reviewNotesEnabled
            reviewNotes {
                note
                createdBy
                created
            }
            onboarding {
                responseType
            }
            practiceGroup
            qualityReviewGroup
            isAIAssistEnabled
`;
export const FIND_MESSAGE = parse(`
    query ($messageId: String!) {
        findMessage(messageId: $messageId) {
            ${MESSAGE}
        }
    }
`);
export const FIND_MESSAGE_AIREVIEW = parse(`
    query ($messageId: String!) {
        getPassiveAIResponse(messageId: $messageId) {
            aiReview {
                createdAt
                reviewCriteria {
                    reviewCriteriaId
                    score
                    reasoning
                }
                reviewNotes
                }
                aiRespond {
                respondResponseCode {
                    responseCode
                    responseCodeDescription
                    reasoning
                }
                respondTags {
                    tags
                    reasoning
                }
                respondClassification {
                    classificationCode
                    classificationCodeDescription
                    reasoning
                }
                respondNextDialogue {
                    nextDialogue
                    nextLifecycleAction
                    reasoning
                }
                lastCustomerDialogueId
                createdAt
                isAIRespondFailed
            }
        }
    }
`);
export const GET_MESSAGE_CONFIG = parse(`
    query ($messageId: String!) {
        getMessageConfig(messageId: $messageId) {
            secureDataOptions {
                type
                name
            }
        }
    }
`);
export const GET_CUSTOMER_SECURE_DATA = parse(`
query ($messageId: String!) {
    getCustomerSecureData(messageId: $messageId) {
        valueName
        value
    }
}
`);